<template>
  <fieldset class="bs3-margin-top bs3-margin-bottom30">
    <legend>
      <i class="fa-light fa-paperclip" aria-hidden="true"></i>
      <span class="bs3-margin-left5">{{ 'dictionary.file.plural' | i18nText(pDictionary) }}</span>
      <a v-if="downloadFileZipButtonVisible" :href="downloadFileZipUrl"
         class="btn btn-sm btn-default bs3-margin-left right show-waiting" style="margin-top: 1px;">
        <i class="fa-light fa-download" aria-hidden="true"></i> {{ 'dictionary.actions.downloadzip' | i18nText(pDictionary) }}</a>
    </legend>

    <input type="hidden" :name="pDataFormInputName + '.fileListRef.id'" :value="pFileListRef.id"/>

    <file-upload-dropzone
        v-if="pFileListDropZoneEnabled"
        :p-currencies="pCurrencies"
        :p-language="pLanguage"
        :p-dictionary="pDictionary"
        :p-parent-id="pParentId"
        :p-data-form-input-name="pDataFormInputName"
        :p-file-list-ref="pFileListRef">
    </file-upload-dropzone>

    <file-preview-list
        :p-currencies="pCurrencies"
        :p-language="pLanguage"
        :p-dictionary="pDictionary"
        :p-urls="pUrls"
        :p-error-list="pErrorList"
        :p-src="pSrc"
        :p-src-id="pSrcId"
        :p-files="files">
    </file-preview-list>
  </fieldset>
</template>

<script>
import refHelpers from '@/helpers/ref-helpers'
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FilePreviewList from "@/components/modules/file-module/file/preview/FilePreviewList";
import FileUploadDropzone from "@/components/modules/file-module/file/upload/FileUploadDropzone";

export default {
  name: "FilesSection",
  components: {FileUploadDropzone, FilePreviewList},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pParentId: {
      type: String,
      required: true
    },
    pDataFormInputName: {
      type: String,
      default: function () {
        return 'dataForm';
      }
    },
    pFileListDropZoneEnabled: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    pFileListRef: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      loading: true,
      files: []
    }
  },
  methods: {
    refreshFiles: function () {
      let _component = this;
      _component.loading = true;
      if(refHelpers.isValidRef(_component.pFileListRef))
      {
        $.ajax({
                 type: "POST",
                 url: "/mediaplan/app/endpoints/json-api/files",
                 data: JSON.stringify({fileListId: _component.pFileListRef.id}),
                 headers: {
                   'Accept': 'application/json',
                   'Content-Type': 'application/json'
                 }
               }).done(function (data) {
          _component.files.splice(0);
          $.each(data, function (index, invoice) {
            _component.files.push(invoice);
          });
          _component.loading = false;
        });
      }
      else
      {
        _component.loading = false;
      }
    }
  },
  computed: {
    downloadFileZipButtonVisible: function () {
      return this.files.length > 0;
    },
    downloadFileZipUrl: function () {
      return this.pUrls['downloadFileZip'] + '?dataId' + this.pFileListRef.id;
    }
  },
  mounted: function () {
    this.refreshFiles();
  }
}
</script>

<style scoped>

</style>